import { render, staticRenderFns } from "./Bkk.vue?vue&type=template&id=3afc97b6&scoped=true&"
import script from "./Bkk.vue?vue&type=script&lang=js&"
export * from "./Bkk.vue?vue&type=script&lang=js&"
import style0 from "./Bkk.vue?vue&type=style&index=0&id=3afc97b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc97b6",
  null
  
)

export default component.exports